import React, { useEffect, useState } from "react";

export default function PendingApprovals() {
  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState("");

  const loadPending = async () => {
    // const data = await fetch("http://localhost:9091/api/admin/auth/pending-approvals");
     const data = await fetch("https://api.mediitacademy.com/api/admin/auth/pending-approvals");
    const json = await data.json();
    setUsers(json);
  };

  useEffect(() => { loadPending(); }, []);

  const handleApprove = async (id: number) => {
    await fetch(`https://api.mediitacademy.com/api/admin/auth/approve/${id}`, { method: "POST" });
    setMsg("User approved standard system entry done.");
    loadPending();
  };

  return (
    <div className="rounded-[34px] border border-slate-200 bg-white p-6 shadow-sm">
      <h2 className="text-xl font-black text-slate-950 mb-4">Pending Approvals</h2>
      {msg && <div className="p-3 mb-4 rounded-xl bg-emerald-50 text-emerald-700 text-sm font-black">{msg}</div>}
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm font-bold text-slate-600">
          <thead>
            <tr className="bg-slate-50 text-slate-400 font-black text-xs uppercase tracking-wider">
              <th className="p-4">Name</th>
              <th className="p-4">Email</th>
              <th className="p-4">Role Requested</th>
              <th className="p-4">Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u: any) => (
              <tr key={u.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="p-4 text-slate-950">{u.name}</td>
                <td className="p-4">{u.email}</td>
                <td className="p-4"><span className="bg-blue-50 text-blue-700 px-2.5 py-1 rounded-md text-xs font-black">{u.role}</span></td>
                <td className="p-4">
                  <button onClick={() => handleApprove(u.id)} className="bg-blue-600 text-white rounded-xl px-4 py-2 text-xs font-black shadow-md shadow-blue-500/10 hover:bg-blue-700">
                    Approve Entry
                  </button>
                </td>
              </tr>
            ))}
            {users.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-slate-400">No registrations pending approval.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}